import React, { useState,useEffect } from "react";
import { useNavigate, Link, useParams, } from "react-router-dom";
import axios from "../api/baseurl";
import { toast} from "react-toastify";
import "./Spinner.css";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Button } from "react-bootstrap";

const EmployeeDetailsModal = ({ isOpen, onRequestClose, userid}) => {
  const navigate = useNavigate();

  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);

  const getData = async () => {
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;
    try {
      const response = await axios.get(
        `/api/employeedetails/getEmployeeDetailsWithProfileImageByUserid/userid=${userid}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log("Response received:", response.data);
      setProfile(response.data);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  
 
    useEffect(() => {
        if (isOpen && userid) {
          getData();
        }
      }, [isOpen, userid]);
      

   function handleError(error) {
      if (error.response) {
        if (error.response.status === 401) {
          navigate(`/signin`);
          toast.error("Your session has expired. Please login.");
        } else if (error.response.data && error.response.data.message) {
          toast.error(error.response.data.message);
        }  else if (error.response.data && error.response.data.code) {
          toast.error(error.response.data.code);
        }
         else {
          toast.error("An error occurred.");
        }
      } else if (error.message) {
        toast.error(error.message);
      } else {
        toast.error("An error occurred.");
      }
    }
  


  return (
    <Modal show={isOpen} onHide={onRequestClose} centered size="lg">
    <Modal.Header closeButton>
    <Modal.Title>Employee Details</Modal.Title>
    </Modal.Header>
    <Modal.Body>
    {loading && <div className="loading"></div>} 
    <div className="col-xl-10 mx-xl-auto">
    <div className="card-body d-flex justify-content-center align-items-start flex-wrap">            
            <div className="card-body">
            {profile?.employeeProfileImage?.image ? (
                              <img
                                className="img-fluid circular-image"
                                id="image"
                                src={`${profile?.employeeProfileImage?.imageMeta},${profile?.employeeProfileImage?.image}`}
                                alt="User Profile"
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  borderRadius: "50%",
                                  background: "#ccc",
                                  lineHeight: "170px",
                                  fontSize: "24px",
                                  marginTop: "20px",
                                }}
                              />
                            ) : (
                              <div
                                className="img-fluid circular-image"
                                id="image"
                                style={{
                                  width: "150px",
                                  height: "150px",
                                  borderRadius: "50%",
                                  background: "#ccc",
                                  lineHeight: "170px",
                                  fontSize: "24px",
                                  marginTop: "15px",
                                }}
                              />
                            )}
                          </div>

                          <div className="col-md-8">
                          
                            <div className="row">
                              <div className="col-md-6">
                                <div className="mb-2">
                                  <strong>First Name:</strong> {profile?.name}
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-2">
                                  <strong>Last Name:</strong> {profile?.lastname}
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-6">
                                <div className="mb-2">
                                  <strong>Phone Number:</strong> {profile?.phoneno}
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-2">
                                  <strong>Email ID:</strong> {profile?.email}
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-6">
                                <div className="mb-2">
                                  <strong>Date Of Birth:</strong> {profile?.dob}
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-2">
                                  <strong>Gender:</strong> {profile?.gender}
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-6">
                                <div className="mb-2">
                                  <strong>Employee Id:</strong> {profile?.empid}
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-2">
                                  <strong>Designation:</strong> {profile?.designation}
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-6">
                                <div className="mb-2">
                                  <strong>Date of Joining:</strong> {profile?.dateOfJoining}
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-2">
                                  <strong>PAN:</strong> {profile?.pan}
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-6">
                                <div className="mb-2">
                                  <strong>Aadhar Number:</strong> {profile?.aadhaarnumber}
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-2">
                                  <strong>Address:</strong> {profile?.address}
                                </div>
                              </div>
                              <div className="row">
                              <div className="col-md-6">
                                <div className="mb-2">
                                  <strong>Location :</strong> {profile?.locations?.location}
                                </div>
                              </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
             
              </Modal.Body>
      <Modal.Footer>
       </Modal.Footer>
    </Modal>
  );
}
export default EmployeeDetailsModal;
